module.exports = __webpack_public_path__ + "static/media/P99.d92d33f1.png";